/**
 *  Created by piotr@revisual.io on 15/03/2026
 */
import UntitledEmptyState from "../../../theme/untitled/EmptyState/EmptyState";
import Icon from "../../../theme/untitled/icons/Icon";

/**
 *
 * @param {number} days
 * @param {function} onRangeChange
 * @param {string} type
 * @returns {JSX.Element}
 * @constructor
 */
function EmptyState({ days, onRangeChange, type = "past" }) {
  const canExpand = days < 90;
  const shownDays = canExpand ? days : 90;
  const nextRange = days === 7 ? 30 : 90;

  return (
    <UntitledEmptyState
      icon={<Icon name="Calendar2" size={24} />}
      title="No event data yet"
      body={`No engagement recorded in the past ${shownDays} days.`}
      actions={
        canExpand && onRangeChange
          ? [
              {
                label: `Try last ${nextRange} days`,
                onClick: onRangeChange(nextRange),
              },
            ]
          : []
      }
    />
  );
}
export default EmptyState;
